import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  faAddressCard,
  faBuilding,
  faChartLine,
  faDatabase,
  faLayerGroup,
  faSignOutAlt,
  faTachographDigital,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../context/AppContext';
import AppSidebar from '../AppSidebar';

const SuperAdminSidebar = ({ isCollapsed, onToggleCollapse }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logoutUser } = useAppContext();

  const isActive = (path) => {
    if (path === '/super-admin') {
      return location.pathname === '/super-admin' || location.pathname === '/super-admin/';
    }

    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/super-admin', label: '대시보드', key: 'dashboard', faIcon: faTachographDigital },
    { path: '/super-admin/analytics', label: '운영 애널리틱스', key: 'analytics', faIcon: faChartLine },
    { path: '/super-admin/enterprises', label: '기업 계정 관리', key: 'enterprises', faIcon: faAddressCard },
    { path: '/super-admin/accounts', label: '일반 계정 관리', key: 'accounts', faIcon: faUsers },
    { path: '/super-admin/companies', label: '기업 관리', key: 'companies', faIcon: faBuilding },
    { path: '/super-admin/domain-templates', label: '도메인 템플릿', key: 'domain-templates', faIcon: faLayerGroup },
    { path: '/super-admin/corpus', label: 'Interview Corpus', key: 'corpus', faIcon: faDatabase },
  ].map((item) => ({
    ...item,
    active: isActive(item.path),
  }));

  const handleLogout = async () => {
    await logoutUser();
    navigate('/super/login');
  };

  return (
    <AppSidebar
      variant="superAdmin"
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
      navSectionLabel="관리"
      navItems={navItems}
      userName={user?.name || 'Super Admin'}
      userEmail={user?.email || 'Super Admin'}
      profileMenuItems={[
        {
          key: 'logout',
          label: '로그아웃',
          icon: faSignOutAlt,
          danger: true,
          onClick: handleLogout,
        },
      ]}
    />
  );
};

export default SuperAdminSidebar;
